import { router } from '@inertiajs/vue3';

export function useImoveisNavigation() {
    const getImoveisRoute = () => route('imoveis');
    const getEmitirBicRoute = () => route('imoveis.bic');
    const getMeusImoveisRoute = () => route('contribuinte.meus-imoveis');

    const goToImoveis = () => router.visit(getImoveisRoute());

    return { getImoveisRoute, getEmitirBicRoute, getMeusImoveisRoute, goToImoveis };
}
